// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    UmbrellaOff,
    Underline,
    Undo,
    Undo2,
    UndoDot,
    UnfoldHorizontal,
    UnfoldVertical,
    Ungroup,
    University,
    Unlink,
    Unlink2,
    Unplug,
    Upload,
    Usb,
    UsbCPort,
    User,
    UserCheck,
    UserCog,
    UserKey,
    UserLock,
    UserMinus,
    UserPen,
    UserPlus,
    UserRound,
    UserRoundArrowLeft,
    UserRoundCheck,
    UserRoundCog,
    UserRoundKey,
    UserRoundMinus,
    UserRoundPen,
    UserRoundPlus,
    UserRoundSearch,
    UserRoundX,
    UserSearch,
    UserShield,
    UserStar,
    UserX,
    Users,
    UsersRound,
    Utensils,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "umbrella-off" through "utensils", inclusive. */
const shard: Record<string, LucideIcon> = {
    "umbrella-off": UmbrellaOff,
    underline: Underline,
    undo: Undo,
    "undo-2": Undo2,
    "undo-dot": UndoDot,
    "unfold-horizontal": UnfoldHorizontal,
    "unfold-vertical": UnfoldVertical,
    ungroup: Ungroup,
    university: University,
    unlink: Unlink,
    "unlink-2": Unlink2,
    unplug: Unplug,
    upload: Upload,
    usb: Usb,
    "usb-c-port": UsbCPort,
    user: User,
    "user-check": UserCheck,
    "user-cog": UserCog,
    "user-key": UserKey,
    "user-lock": UserLock,
    "user-minus": UserMinus,
    "user-pen": UserPen,
    "user-plus": UserPlus,
    "user-round": UserRound,
    "user-round-arrow-left": UserRoundArrowLeft,
    "user-round-check": UserRoundCheck,
    "user-round-cog": UserRoundCog,
    "user-round-key": UserRoundKey,
    "user-round-minus": UserRoundMinus,
    "user-round-pen": UserRoundPen,
    "user-round-plus": UserRoundPlus,
    "user-round-search": UserRoundSearch,
    "user-round-x": UserRoundX,
    "user-search": UserSearch,
    "user-shield": UserShield,
    "user-star": UserStar,
    "user-x": UserX,
    users: Users,
    "users-round": UsersRound,
    utensils: Utensils,
};

export default shard;
